/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ProfileInputs */

const en_nav_profile = /** @type {(inputs: Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const ja_nav_profile = /** @type {(inputs: Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィール`)
};

const fr_nav_profile = /** @type {(inputs: Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

const de_nav_profile = /** @type {(inputs: Nav_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Nav_ProfileInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_profile = /** @type {((inputs?: Nav_ProfileInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ProfileInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_profile(inputs)
	if (locale === "ja") return ja_nav_profile(inputs)
	if (locale === "fr") return fr_nav_profile(inputs)
	return de_nav_profile(inputs)
});